import { lazy } from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const MyMedia = lazy(() => import("@mediaspace/features/my-media"));

export const render = getDsLayoutComponentRenderer(MyMedia);

export * as bulkItems from "@mediaspace/features/my-media/bulk-actions";
export * as kafItems from "@mediaspace/features/my-media/kaf-actions";
